import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  "class": "flex flex-col w-full h-full text-white"
};
var _hoisted_2 = {
  "class": "flex items-center justify-center flex-1"
};
var _hoisted_3 = /*#__PURE__*/_createElementVNode("p", {
  "class": "mb-md"
}, " We have noticed that you are trying to access our service from one of the restricted countries. Please note that per our Terms of Use and in compliance with local regulation, we are unable to provide our services in your region. ", -1);
var _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, [/*#__PURE__*/_createTextVNode(" Please "), /*#__PURE__*/_createElementVNode("a", {
  href: "https://intercom.help/bequant/en/collections/3030720-bequant-prime-brokerage",
  "class": "text-primary underline hover:text-primary-hover"
}, "contact"), /*#__PURE__*/_createTextVNode(" customer service if you believe you received this message in an error. ")], -1);
import Header from "@/layouts/main-layout/Header.vue";
import Footer from "@/layouts/main-layout/Footer.vue";
export default {
  __name: 'Restricted',
  setup: function setup(__props) {
    return function (_ctx, _cache) {
      var _component_PBStatus = _resolveComponent("PBStatus");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(Header, {
        empty: ""
      }), _createElementVNode("div", _hoisted_2, [_createVNode(_component_PBStatus, {
        warning: "",
        empty: "",
        width: "768px",
        message: "Service Suspended for Restricted Countries"
      }, {
        "default": _withCtx(function () {
          return [_hoisted_3, _hoisted_4];
        }),
        _: 1
      })]), _createVNode(Footer, {
        empty: ""
      })]);
    };
  }
};